<div class="relative">
  <!-- Main Image -->
  <div class="skeleton-shimmer relative rounded-xl overflow-hidden">
    <div class="h-[40vh] md:h-[50vh] 2xl:h-[60vh] w-full rounded-xl"></div>
  </div>

  <!-- Thumbnails -->
  <div class="flex items-center gap-2 mt-2.5 overflow-x-auto">
    <!-- Left Arrow -->
    <div
      class="skeleton-shimmer relative flex-none h-[90px] w-[30px] rounded"
    ></div>

    <!-- Thumbnails (skeleton) -->
    <div class="grid grid-cols-2 md:grid-cols-5 w-full gap-2">
      <div
        class="skeleton-shimmer relative h-[90px] rounded-lg hidden md:block"
        *ngFor="let thumb of [1, 2, 3, 4, 5]"
      ></div>
      <div
        class="skeleton-shimmer relative h-[90px] rounded-lg md:hidden"
        *ngFor="let thumb of [1, 2]"
      ></div>
    </div>

    <!-- Right Arrow -->
    <div
      class="skeleton-shimmer relative flex-none h-[90px] w-[30px] rounded"
    ></div>
  </div>
  <div class="skeleton-shimmer relative h-[200px] w-full rounded mt-4"></div>
</div>
